const categories = {
  slug: 'd/categories',
  categoriesQuicksearch: () => `${categories.slug}/quicksearch`
}

export default categories
